import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=26c0cae5&"
import script from "./delivery.vue?vue&type=script&lang=ts&"
export * from "./delivery.vue?vue&type=script&lang=ts&"
import style0 from "./delivery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports